import { headers as currentStateHeaders } from '@/constants/currentStateConstants.js';
import { ReportConversionUtil, ValueText, TimeFormat, Util } from '@colven/common-domain-lib/lib';
import {getTimestampColor, speedDetentionToStringTranslated} from '../tools/functions'
import i18n from '@/i18n';




export const currentStateService = (function () {
  'use strict';

  async function processCurrentStateData(data) {

    const lang = localStorage.getItem('lang') || 'es';
    const timezone = localStorage.getItem('timezone'); 
    const offSet = timezone ? parseInt(timezone) : -(new Date().getTimezoneOffset() / 60); 

     const headerOptions = {
      engineState: [
        i18n.t('currentState.HEADERS.ENGINE_STATE_ON', { lang }),
        i18n.t('currentState.HEADERS.ENGINE_STATE_OFF', { lang }),
      ],
      boolean: [i18n.t('utils.YES', { lang }), i18n.t('utils.NO', { lang })],
    };

    data.forEach(item => {
        item.typeName = item.typeName ? item.typeName[lang] : '';
        item.eventName = item.eventType ? item.eventType[lang] : '';
        item.coordinates = item.lat && item.long ?
         `${item.lat}, ${item.long}`
        : '';

        item.positionTimestampColor = getTimestampColor(item.positionTimestamp);
        item.comunicationTimestampColor = getTimestampColor(item.comunicationTimestamp); // respetar orden
        let positionTimestampConversion = ReportConversionUtil.applyTimezone(item.positionTimestamp,offSet);
        item.positionTimestamp = positionTimestampConversion.dateString + ' ' + positionTimestampConversion.timeString;
        let  communicationTimestampConversion = ReportConversionUtil.applyTimezone(item.comunicationTimestamp,offSet);
        item.comunicationTimestamp = communicationTimestampConversion.dateString + ' ' + communicationTimestampConversion.timeString;
        
        item.engineState = {
          text:
            item.engineRunning === true
              ? i18n.t('currentState.HEADERS.ENGINE_STATE_ON', { lang })
              : item.engineRunning === false
                ? i18n.t('currentState.HEADERS.ENGINE_STATE_OFF', { lang })
                : undefined,
          value: item.engineRunning,
        }
        item.engineStateColor = item.engineRunning === true ? '#66BB6A' : item.engineRunning === false ? '#263238' : '#263238';
        item.speed= item.speed
          ? new ValueText(
              item.speed,
              speedDetentionToStringTranslated(
                item.speed,
                item.direction,
                item.stopped,
                item.stoppedTime,
                item.trackTimestamp,
                lang,
              ),
            )
          : undefined

        item.hourMeter = item.hourMeter
          ? new ValueText(
              item.hourMeter,
              ReportConversionUtil.secondsToStringFormatted(item.hourMeter, TimeFormat.HH_MM_SS),
            )
          : undefined,
        // odometro
        item.odometer = item.odometer
          ? new ValueText(Util.roundDecimals(item.odometer), `${Util.roundDecimals(item.odometer)} Km`)
          : undefined
      
    });
    const headers = currentStateHeaders(lang, headerOptions);

    console.log('Generated headers:', headers);
    return { data, headers };
  }

  return {
    processCurrentStateData
  };
})();
